import React from 'react'
import { Checkbox, ListItemButton, ListItemIcon } from '@mui/material'
import WorkOrderStatusChip from 'components/work-order/WorkOrderStatusChip'

const RenderFilterOption = (props, option, { selected }) => {
  const { value } = option

  return (
    <ListItemButton dense disableGutters {...props}>
      <ListItemIcon sx={{ minWidth: 0 }}>
        <Checkbox checked={selected} />
      </ListItemIcon>
      <WorkOrderStatusChip status={value} />
    </ListItemButton>
  )
}

RenderFilterOption.propTypes = {}

export default RenderFilterOption
